import { useScanDeviceApiDelete } from '@hooks/api/useScanDeviceApiDelete';
import type { VrsType } from 'types/api';

export const useVrsTypeDelete = useScanDeviceApiDelete<VrsType>('/vrs-types');
